/**
 * Resaltado temporal del pedido recién generado / aprobado.
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = 'gobikHighlightOrder';
  var RELOAD_COUNT_KEY = 'gobikHighlightReloadCount';
  var MAX_RELOAD_ATTEMPTS = 12;
  var TTL_MS = 180000;
  var HIGHLIGHT_CLASS = 'gobik-order-highlight';
  var HIGHLIGHT_MS = 8000;
  var STYLE_ID = 'gobik-order-highlight-style';
  var applyTimer = null;

  function trimStr(v) {
    return v == null ? '' : String(v).trim();
  }

  /** Normaliza IDs Shopify (gid) y numéricos para comparar filas. */
  function normalizeOrderKey(id) {
    var s = trimStr(id);
    if (!s) return '';
    return s
      .replace(/^gid:\/\/shopify\/(Order|DraftOrder)\//i, '')
      .replace(/[^0-9A-Za-z_-]/g, '');
  }

  function normalizeName(v) {
    return trimStr(v).replace(/^#/, '').toLowerCase();
  }

  function onlyDigits(v) {
    return trimStr(v).replace(/[^0-9]/g, '');
  }

  function ensureStyle() {
    if (!global.document || global.document.getElementById(STYLE_ID)) return;
    var css =
      '.' + HIGHLIGHT_CLASS + '{' +
      'position:relative;' +
      'outline:2px solid #2f6bff;' +
      'outline-offset:-2px;' +
      'border-radius:6px;' +
      'box-shadow:0 0 0 4px rgba(47,107,255,0.15);' +
      'background-color:rgba(47,107,255,0.06)!important;' +
      'animation:gobikOrderHighlightPulse 1.2s ease-in-out 2;' +
      'transition:box-shadow .4s ease,outline-color .4s ease,background-color .4s ease;' +
      'scroll-margin-top:120px;' +
      '}' +
      '.' + HIGHLIGHT_CLASS + '__badge{' +
      'position:absolute;top:-10px;left:12px;z-index:5;' +
      'background:#2f6bff;color:#fff;' +
      'font-size:11px;line-height:1;font-weight:600;' +
      'padding:4px 8px;border-radius:999px;' +
      'box-shadow:0 2px 6px rgba(0,0,0,0.18);' +
      'white-space:nowrap;pointer-events:none;' +
      'font-family:inherit;letter-spacing:.2px;' +
      '}' +
      '@keyframes gobikOrderHighlightPulse{' +
      '0%{box-shadow:0 0 0 4px rgba(47,107,255,0.28)}' +
      '50%{box-shadow:0 0 0 8px rgba(47,107,255,0.10)}' +
      '100%{box-shadow:0 0 0 4px rgba(47,107,255,0.15)}' +
      '}';
    var style = global.document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    (global.document.head || global.document.documentElement).appendChild(style);
  }

  function collectOrderIds(info) {
    info = info || {};
    var ids = [];
    function pushId(id) {
      var d = onlyDigits(id) || normalizeOrderKey(id);
      if (d && ids.indexOf(d) === -1) ids.push(d);
    }
    if (Array.isArray(info.orderIds)) {
      info.orderIds.forEach(pushId);
    }
    if (info.order_ids && typeof info.order_ids === 'object' && !Array.isArray(info.order_ids)) {
      Object.keys(info.order_ids).forEach(function (key) {
        pushId(info.order_ids[key]);
      });
    } else if (Array.isArray(info.order_ids)) {
      info.order_ids.forEach(pushId);
    }
    pushId(info.orderId);
    return ids;
  }

  function buildPayload(info) {
    info = info || {};
    var orderIds = collectOrderIds(info);
    return {
      draftOrderId: normalizeOrderKey(info.draftOrderId) || null,
      orderId: orderIds[0] || null,
      orderIds: orderIds,
      name: trimStr(info.name) || null,
      tab: trimStr(info.tab) || null,
      ts: Date.now(),
    };
  }

  /** Guarda en sessionStorage sin resaltar (hasta navegar o apply explícito). */
  function store(info) {
    var payload = buildPayload(info);
    if (!payload.draftOrderId && !payload.orderId && !payload.name && !(payload.orderIds && payload.orderIds.length)) return;
    try {
      global.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  /** Guarda y, solo si opts.apply === true, programa resaltado en la página actual. */
  function remember(info, opts) {
    opts = opts || {};
    store(info);
    if (opts.apply === true) {
      scheduleApply();
    }
  }

  function read() {
    try {
      var raw = global.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var payload = JSON.parse(raw);
      if (!payload || typeof payload !== 'object') return null;
      if (!payload.ts || Date.now() - payload.ts > TTL_MS) {
        clear();
        return null;
      }
      if ((!payload.orderIds || !payload.orderIds.length) && payload.orderId) {
        payload.orderIds = [onlyDigits(payload.orderId) || normalizeOrderKey(payload.orderId)].filter(
          Boolean
        );
      }
      return payload;
    } catch (e) {
      return null;
    }
  }

  function clear() {
    try {
      global.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function activateTab(tabId) {
    if (!tabId || !global.document) return false;
    var link = global.document.getElementById(tabId);
    if (!link) return false;
    link.click();
    return true;
  }

  function keysMatch(stored, candidate) {
    if (!stored || !candidate) return false;
    return normalizeOrderKey(stored) === normalizeOrderKey(candidate);
  }

  function findRows(payload) {
    var doc = global.document;
    if (!doc || !payload) return [];

    var tab = trimStr(payload.tab);
    var searchPending = !tab || tab === 'pedidos-pendientes-tab';
    var searchOrders = !tab || tab === 'pedidos-tab';
    var found = [];
    var seen = [];

    function addRow(row) {
      if (!row) return;
      for (var i = 0; i < seen.length; i++) {
        if (seen[i] === row) return;
      }
      seen.push(row);
      found.push(row);
    }

    if (searchPending && payload.draftOrderId) {
      var draftKey = normalizeOrderKey(payload.draftOrderId);
      if (draftKey) {
        var byId = doc.getElementById('order-' + draftKey);
        if (byId) addRow(byId);
        var rows = doc.querySelectorAll('[data-highlight-draft-id]');
        for (var i = 0; i < rows.length; i++) {
          if (keysMatch(payload.draftOrderId, rows[i].getAttribute('data-highlight-draft-id'))) {
            addRow(rows[i]);
          }
        }
      }
    }

    if (searchOrders) {
      var orderIdList =
        payload.orderIds && payload.orderIds.length
          ? payload.orderIds
          : payload.orderId
            ? [payload.orderId]
            : [];
      if (orderIdList.length) {
        var rowsById = doc.querySelectorAll('[data-highlight-order-id]');
        orderIdList.forEach(function (targetId) {
          var oid = onlyDigits(targetId);
          if (!oid) return;
          for (var j = 0; j < rowsById.length; j++) {
            if (onlyDigits(rowsById[j].getAttribute('data-highlight-order-id')) === oid) {
              addRow(rowsById[j]);
            }
          }
        });
      }
    }

    if (payload.name) {
      var target = normalizeName(payload.name);
      if (target) {
        var rowsByName = doc.querySelectorAll('[data-highlight-order-name]');
        for (var k = 0; k < rowsByName.length; k++) {
          var row = rowsByName[k];
          var inPending = !!row.getAttribute('data-highlight-draft-id');
          var inOrders = !!row.getAttribute('data-highlight-order-id') || row.classList.contains('orderGobik');
          if (tab === 'pedidos-tab' && inPending && !inOrders) continue;
          if (tab === 'pedidos-pendientes-tab' && inOrders && !inPending) continue;
          if (normalizeName(row.getAttribute('data-highlight-order-name')) === target) {
            addRow(row);
          }
        }
      }
    }

    return found;
  }

  function revealRow(row) {
    if (!row) return;
    var tab = row.closest('.tab_content');
    if (tab && tab.style.display === 'none') {
      var pos = tab.getAttribute('data-section-position');
      if (pos) {
        var link = global.document.querySelector(
          '.sidebar a[data-section-position="' + pos + '"]'
        );
        if (link) link.click();
      }
    }
  }

  function showOrdersTabWaitingCard() {
    var doc = global.document;
    if (!doc) return;
    var container = doc.querySelector(
      '.customer-order-list-rocket.tab_content[data-section-position="1"]'
    );
    if (!container || container.querySelector('.gobik-orders-awaiting-card')) return;
    var card = doc.createElement('div');
    card.className = 'web-order-processing-card gobik-orders-awaiting-card';
    card.innerHTML =
      '<div class="web-order-processing-card__spinner" aria-hidden="true"></div>' +
      '<div class="web-order-processing-card__text"><strong>' +
      (global.GOBIK_ORDERS_AWAITING_TITLE || 'Actualizando listado de pedidos') +
      '</strong><span>' +
      (global.GOBIK_ORDERS_AWAITING_HINT || 'Tu pedido aparecerá en unos segundos…') +
      '</span></div>';
    var datePicker = container.querySelector(
      '.customer-order-list-rocket__date-picker-container'
    );
    if (datePicker && datePicker.nextSibling) {
      container.insertBefore(card, datePicker.nextSibling);
    } else if (datePicker) {
      container.appendChild(card);
    } else {
      container.insertBefore(card, container.firstChild);
    }
  }

  function clearReloadCount() {
    try {
      global.sessionStorage.removeItem(RELOAD_COUNT_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function scheduleReloadForPendingHighlight() {
    var reloadCount = 0;
    try {
      reloadCount = parseInt(global.sessionStorage.getItem(RELOAD_COUNT_KEY) || '0', 10);
    } catch (e) {
      reloadCount = 0;
    }
    if (reloadCount >= MAX_RELOAD_ATTEMPTS) {
      clearReloadCount();
      return;
    }
    try {
      global.sessionStorage.setItem(RELOAD_COUNT_KEY, String(reloadCount + 1));
    } catch (e) {
      /* ignore */
    }
    showOrdersTabWaitingCard();
    global.setTimeout(function () {
      global.location.reload();
    }, 2500);
  }

  function highlightRow(row) {
    if (!row || row.classList.contains(HIGHLIGHT_CLASS)) return;
    revealRow(row);
    ensureStyle();
    row.classList.add(HIGHLIGHT_CLASS);

    var badge = global.document.createElement('span');
    badge.className = HIGHLIGHT_CLASS + '__badge';
    badge.textContent = global.GOBIK_HIGHLIGHT_BADGE_TEXT || 'Pedido generado';
    if (getComputedStyle(row).position === 'static') {
      row.style.position = 'relative';
    }
    row.appendChild(badge);

    global.requestAnimationFrame(function () {
      try {
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        row.scrollIntoView();
      }
    });

    global.setTimeout(function () {
      row.classList.remove(HIGHLIGHT_CLASS);
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    }, HIGHLIGHT_MS);
  }

  function apply(options) {
    options = options || {};
    if (!global.document) return;

    var payload = read();
    if (!payload) return;

    if (payload.tab) {
      var hash = global.location.hash ? global.location.hash.replace(/^#/, '') : '';
      if (hash !== payload.tab) {
        activateTab(payload.tab);
      }
    }

    var attempts = 0;
    var maxAttempts = options.maxAttempts || 60;
    var intervalMs = options.intervalMs || 500;

    function attempt() {
      attempts++;
      var rows = findRows(payload);
      if (rows.length) {
        rows.forEach(highlightRow);
        var expected =
          payload.orderIds && payload.orderIds.length > 1 ? payload.orderIds.length : 1;
        if (rows.length >= expected) {
          clear();
          clearReloadCount();
          return;
        }
      }
      if (attempts < maxAttempts) {
        applyTimer = global.setTimeout(attempt, intervalMs);
        return;
      }
      if (rows.length) {
        clear();
        clearReloadCount();
        return;
      }
      if (payload.tab === 'pedidos-tab') {
        scheduleReloadForPendingHighlight();
      }
    }

    if (applyTimer) {
      global.clearTimeout(applyTimer);
      applyTimer = null;
    }
    attempt();
  }

  function scheduleApply() {
    if (applyTimer) global.clearTimeout(applyTimer);
    applyTimer = global.setTimeout(function () {
      applyTimer = null;
      apply();
    }, 120);
  }

  global.GobikOrderHighlight = {
    STORAGE_KEY: STORAGE_KEY,
    store: store,
    remember: remember,
    apply: apply,
    scheduleApply: scheduleApply,
    clear: clear,
    normalizeOrderKey: normalizeOrderKey,
  };

  if (global.document) {
    global.document.addEventListener('DOMContentLoaded', function () {
      scheduleApply();
    });
    global.addEventListener('gobik:orders-rendered', scheduleApply);
    global.addEventListener('pageshow', function (evt) {
      if (evt && evt.persisted) scheduleApply();
    });
  }
})(typeof window !== 'undefined' ? window : this);
